import {
    configureStore,
    getDefaultMiddleware,
    combineReducers,
} from '@reduxjs/toolkit'

import {
    //persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist'

import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import storage from 'redux-persist/lib/storage'

import shiftModalReducer from '../features/ShiftModal/shiftModalSlice'
import plivoModalReducer from '../features/PlivoModal/plivoModalSlice'
import mailModalReducer from '../features/MailModal/mailModalSlice'
import timesheetReducer from '../features/Timesheet/timesheetSlice'
import fileReducer from '../features/File/fileSlice'
import bottomNavReducer from '../features/BottomNav/bottomNavSlice'
import snackbarMessageReducer from '../features/SnackbarMessage/snackbarMessageSlice'

import userReducer from '../features/User/userSlice.js'
import shiftCollectionReducer from '../features/ShiftCollection/shiftCollectionSlice.js'

// for modals, back button, etc
import navStackReducer from '../features/NavStack/navStackSlice'

const persistConfig = {
    key: 'root',
    version: 1,
    storage: storage,
    stateReconciler: autoMergeLevel2,

    blacklist: [
        'modal',
        'shiftModal',
        'bottomNav',
        'plivo',
        'mailModal',
        'timesheet',
        'file',
        'navStack',
        'snackbarMessage',
    ],
}

export const rootReducer = combineReducers({
    user: userReducer,
    shiftCollections: shiftCollectionReducer,
    plivo: plivoModalReducer,
    shiftModal: shiftModalReducer,
    mailModal: mailModalReducer,
    timesheet: timesheetReducer,
    bottomNav: bottomNavReducer,
    file: fileReducer,
    navStack: navStackReducer,
    snackbarMessage: snackbarMessageReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export default configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
    }),
})
